import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "lucide-react";
import { useLanguage } from "@/i18n";

export const ConfirmDialog = ({ 
  open, 
  onOpenChange, 
  title, 
  message, 
  confirmText, 
  cancelText, 
  variant = "default",
  onConfirm 
}) => {
  const { t } = useLanguage();
  const confirmLabel = confirmText || t('confirm');
  const cancelLabel = cancelText || t('cancel');
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-w-sm">
        <DialogHeader>
          <DialogTitle className={`text-white flex items-center gap-2 ${variant === 'danger' ? 'text-red-400' : ''}`}>
            {variant === 'danger' ? <XCircle size={20} /> : <CheckCircle size={20} />}
            {title}
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-zinc-300">{message}</p>
        </div>
        
        <div className="flex gap-3 justify-end">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            className="border-zinc-700 text-zinc-300 hover:bg-zinc-800"
          >
            {cancelLabel}
          </Button>
          <Button 
            onClick={async () => {
              if (onConfirm) {
                await onConfirm();
              }
              onOpenChange(false);
            }}
            className={variant === 'danger' 
              ? 'bg-red-600 hover:bg-red-700 text-white' 
              : 'bg-blue-600 hover:bg-blue-700'
            }
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
